import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('video-player-ui');